class pdpInfo extends HTMLElement {
  static observedAttributes = ['current-variant-id']

  constructor() {
    super()

    const variantInfoScript = this.querySelector(
      'script[type="application/json"]#variant-info'
    )
    const productInfoScript = this.querySelector(
      'script[type="application/json"]#product-info'
    )

    this.variantInfo = variantInfoScript
      ? JSON.parse(variantInfoScript.textContent)
      : {}
    this.productInfo = productInfoScript
      ? JSON.parse(productInfoScript.textContent)
      : {}

    this.currentVariantId = this.getAttribute('current-variant-id')

    if (this.currentVariantId) this.updateDescritions()
  }

  connectedCallback() {
    window.addEventListener(
      'variant-change',
      this.handleVariantChange.bind(this)
    )
  }

  disconnectedCallback() {
    window.removeEventListener('variant-change', this.handleVariantChange)
  }

  attributeChangedCallback(name, _, newValue) {
    if (name === 'current-variant-id') {
      this.currentVariantId = newValue

      if (this.currentVariantId) this.updateDescritions()
    }
  }

  handleVariantChange(e) {
    const {
      variant: { id },
    } = e.detail
    this.setAttribute('current-variant-id', id)
  }

  updateDescritions() {
    const infoAccordionsContents = this.querySelectorAll('[data-info-handle]')
    const currentVariantInfo = this.variantInfo[this.currentVariantId]
    const defaultProductInfo = this.productInfo

    if (!infoAccordionsContents) return

    for (const accordion of infoAccordionsContents) {
      const accordionContent = accordion
      const { infoHandle } = accordion.dataset

      switch (infoHandle) {
        case 'product-description':
          accordionContent.innerHTML = currentVariantInfo.description
            ? currentVariantInfo.description
            : defaultProductInfo.description
          break
        default:
          accordionContent.innerHTML =
            currentVariantInfo.additional_info &&
            infoHandle in currentVariantInfo.additional_info
              ? currentVariantInfo.additional_info[infoHandle]
              : defaultProductInfo.additional_info[infoHandle]
          break
      }
    }
  }
}

customElements.define('pdp-info', pdpInfo)
